import { createSlice } from '@reduxjs/toolkit';
import { resetToInitialState } from '~/reducers/common-actions';

export const usersByIdSlice = createSlice({
    name: 'usersById',
    initialState: {},
    reducers: {
        setUsersById: (state, action) => {
            return action.payload;
        },
        updateUserById: (state, action) => {
            const newState = { ...state };
            newState[action.payload.id] = action.payload;
            return newState;
        },
        resetUsersById: () => {
            return {};
        }
    },
    extraReducers: (builder) => {
        builder.addCase(resetToInitialState, () => {
            return {};
        });
    }
});

export const { setUsersById, updateUserById, resetUsersById } =
    usersByIdSlice.actions;

export const selectUsersById = (state) => state.usersById;

export default usersByIdSlice.reducer;
